import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { DatePipe, ViewportScroller } from "@angular/common";
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import * as countrycitystatejson from 'countrycitystatejson';
import { environment } from 'src/environments/environment';
import { VendorService, vendorData } from 'src/app/_services/vendor.service';
import { CommonService } from 'src/app/_services/common.service';
import { ZipCodeService } from 'src/app/_services/zip-code.service';
import { state } from '@angular/animations';


interface Country {
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-edit-vendor',
  templateUrl: './edit-vendor.component.html',
  styleUrls: ['./edit-vendor.component.css'],
  providers: [DatePipe]

})
export class EditVendorComponent implements OnInit {
  vendorData: vendorData;
  selectedFile: FileList | any;
  curDate = new Date();
  countries: Country[];
  cities: string[];
  states: any[];
  private countryData = countrycitystatejson;

  constructor(public route: ActivatedRoute,
    private loginService: LoginService,
    private authService: AuthService,
    public commonService: CommonService,
    private alertService: AlertService,
    public vendorService: VendorService,
    private zipCodeService: ZipCodeService,
    private datePipe: DatePipe,
    private _liveAnnouncer: LiveAnnouncer,
    private router: Router) {
    this.years = this.commonService.getYearRange();
  }

  submitted: boolean = true;
  status: boolean = false;
  statusBank: boolean = false;
  statusSec: boolean = false;
  file: File = null;
  vendorId: any;
  years: number[] = [];
  selectedYear: number | null = null;
  vendorRegistrationId: any
  isLoading: boolean = false;
  isLoad: boolean = false;
  isBankLoad: boolean = false;
  isSecLoad: boolean = false;
  File: File;
  dataa: [] = [];
  IsVendorActive: any;
  vendorDetailRespone: any;
  updatedVendorField:string[];
  custId = this.authService.getRegistredUserDetails().customerId;
  token = this.authService.getToken();

  @ViewChild(MatPaginator) private paginator: MatPaginator;
  public dataSource = new MatTableDataSource<any>(this.dataa);
  public displayedColumns: string[] = ['documentName', 'w9VerifiedYear', 'typeOfDoc', 'createdDate', 'Edit'];
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  @ViewChild('empTbSort') empTbSort = new MatSort();

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.empTbSort;
  }

  async ngOnInit() {
    // await this.vendorState();
    this.editVendorData();
    this.updateYears();
  }
  
  editVendorData() {
    this.isLoading = true;
    this.fileForm.value.documentName = 0;
    this.vendorService.vendorDetails(this.route.snapshot.params.vendorRegistrationId, '', this.token)
      .subscribe((result) => {
        this.vendorDetailRespone = result;
        console.log(result);
        console.log('state', result['state'])
        const mockEvent = {
          target: { value: result['zip'] }
        }
        this.onZipCodeChange(mockEvent);
        this.vendorDocsDetails(result['vendorRegistrationId']);
        this.vendorId = result['vendorId'];
        this.vendorRegistrationId = result['vendorRegistrationId'];
        this.IsVendorActive = result['isVendorActive'];
        this.primaryForm.disable();
        this.primaryForm = new FormGroup({
          customerId: new FormControl(this.custId),
          vendorId: new FormControl(result['vendorId'], [Validators.required]),
          lastName: new FormControl(result['lastName'], [Validators.required]),
          email: new FormControl(result['email'], [
            Validators.required,
            Validators.email,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
          ]),
          phone: new FormControl(result['phone'],
            [
              Validators.required,
              Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
            ]),
          addr1: new FormControl(result['addr1']),
          addr2: new FormControl(result['addr2']),
          vendorRegistrationId: new FormControl(result['vendorRegistrationId']),
          nameOfBank: new FormControl(result['nameOfBank']),
          accountType: new FormControl(result['accountType']),
          accountNumber: new FormControl(result['accountNumber']),
          bankRoutingNumber: new FormControl(result['bankRoutingNumber']),
          companyTaxId: new FormControl(result['companyTaxId']),
          bankAddress: new FormControl(result['bankAddress']),
          city: new FormControl(result['city']),
          state: new FormControl(result['state']),
          zip: new FormControl(result['zip']),
          country: new FormControl('US'),
          bankContact: new FormControl(result['bankContact']),
          paymentEmailAddress: new FormControl(result['paymentEmailAddress']),
          secondaryOtherDetail: new FormControl(result['secondaryOtherDetail']),
          secondaryEmail: new FormControl(result['secondaryEmail']),
          secondaryPhone: new FormControl(result['secondaryPhone']),
          secondaryCompanyContact: new FormControl(result['secondaryCompanyContact']),
          companyName: new FormControl(result['companyName'],[Validators.required]),
          companyContact: new FormControl(result['phone']),
          isVendorActive: new FormControl(result['isVendorActive']),
          paymentElection: new FormControl('ACH')
        })

        this.bankForm.disable();
        this.bankForm = new FormGroup(
          {
            customerId: new FormControl(this.custId),
            vendorRegistrationId: new FormControl(result['vendorRegistrationId']),
            lastName: new FormControl(result['lastName']),
            email: new FormControl(result['email']),
            phone: new FormControl(result['phone']),
            vendorId: new FormControl(result['vendorId']),
            addr1: new FormControl(result['addr1']),
            addr2: new FormControl(result['addr2']),
            nameOfBank: new FormControl(result['nameOfBank'], [Validators.required]),
            accountType: new FormControl(result['accountType'], [Validators.required]),
            accountNumber: new FormControl(result['accountNumber'], [Validators.required]),
            ConfirmAccNum: new FormControl(result['accountNumber'], [Validators.required]),
            bankRoutingNumber: new FormControl(result['bankRoutingNumber'], [Validators.required]),
            companyTaxId: new FormControl(result['companyTaxId'], [Validators.required]),
            bankAddress: new FormControl(result['bankAddress'], [Validators.required]),
            city: new FormControl(result['city'], [Validators.required]),
            state: new FormControl(result['state'], [Validators.required]),
            zip: new FormControl(result['zip'], [
              Validators.required,
              Validators.minLength(5),
              Validators.maxLength(5)
            ]),
            country: new FormControl('US', [Validators.required]),
            bankContact: new FormControl(result['bankContact'],
              [
                Validators.required,
                Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
              ]),
            paymentEmailAddress: new FormControl(result['paymentEmailAddress'],
              [
                Validators.required,
                Validators.email,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
              ]),
            secondaryOtherDetail: new FormControl(result['secondaryOtherDetail']),
            secondaryEmail: new FormControl(result['secondaryEmail']),
            secondaryPhone: new FormControl(result['secondaryPhone']),
            secondaryCompanyContact: new FormControl(result['secondaryCompanyContact']),
            companyName: new FormControl(result['companyName']),
            companyContact: new FormControl(result['phone']),
            isVendorActive: new FormControl(result['isVendorActive']),
            paymentElection: new FormControl('ACH')
          }
        )

        this.secondaryForm.disable();
        this.secondaryForm = new FormGroup(
          {
            customerId: new FormControl(this.custId),
            secondaryOtherDetail: new FormControl(result['secondaryOtherDetail']),
            secondaryEmail: new FormControl(result['secondaryEmail'],
              [
                Validators.required,
                Validators.email,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
              ]),
            secondaryPhone: new FormControl(result['secondaryPhone'],
              [
                Validators.required,
                Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
              ]),
            secondaryCompanyContact: new FormControl(result['secondaryCompanyContact'],
              [
                Validators.required
              ]),
            vendorRegistrationId: new FormControl(result['vendorRegistrationId']),
            lastName: new FormControl(result['lastName']),
            email: new FormControl(result['email']),
            phone: new FormControl(result['phone']),
            addr1: new FormControl(result['addr1']),
            addr2: new FormControl(result['addr2']),
            vendorId: new FormControl(result['vendorId']),
            nameOfBank: new FormControl(result['nameOfBank']),
            accountType: new FormControl(result['accountType']),
            accountNumber: new FormControl(result['accountNumber'],),
            bankRoutingNumber: new FormControl(result['bankRoutingNumber']),
            companyTaxId: new FormControl(result['companyTaxId']),
            bankAddress: new FormControl(result['bankAddress']),
            city: new FormControl(result['city']),
            state: new FormControl(result['state']),
            zip: new FormControl(result['zip'], [
              Validators.minLength(5),
              Validators.maxLength(5)
            ]),
            country: new FormControl(result['country']),
            bankContact: new FormControl(result['bankContact'],
              [
                Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
              ]),
            paymentEmailAddress: new FormControl(result['paymentEmailAddress'],
              [
                Validators.email,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
              ]),
            companyName: new FormControl(result['companyName']),
            companyContact: new FormControl(result['phone']),
            isVendorActive: new FormControl(result['isVendorActive']),
            paymentElection: new FormControl('ACH'),
          })
      })

    // this.onZipCodeChange();
    // if (this.bankForm.value.country) {
    //   this.states = this.getStatesByCountry(this.bankForm.value.country);
    //   console.log(this.states)
    //   this.bankForm.get('state').enable();
    // }
    this.updatedVendorField = [];
    this.isLoading = false;
  }

  onStateClick(event) {
    // var state = event.value;
    // console.log("statee", state);
    // if (state) {
    //   this.cities = this.getCitiesByState(this.bankForm.value.country, state);
    //   console.log(this.cities)
    //   this.bankForm.get('city').enable();
    // }
  }


  primaryForm: FormGroup = new FormGroup(
    {
      paymentElection: new FormControl('ACH'),
      isVendorActive: new FormControl(false),
      vendorId: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      vendorRegistrationId: new FormControl('', [Validators.required]),
      addr1: new FormControl(''),
      addr2: new FormControl(''),
      customerId: new FormControl(this.custId),
      nameOfBank: new FormControl('', [Validators.required]),
      accountType: new FormControl('', [Validators.required]),
      accountNumber: new FormControl('', [Validators.required]),
      bankRoutingNumber: new FormControl('', [Validators.required]),
      companyTaxId: new FormControl('', [Validators.required]),
      bankAddress: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zip: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ]),
      country: new FormControl('US', [Validators.required]),
      bankContact: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      paymentEmailAddress: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      companyName: new FormControl('', [Validators.required]),
      companyContact: new FormControl(''),
      secondaryOtherDetail: new FormControl(''),
      secondaryEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      secondaryPhone: new FormControl(''),
      secondaryCompanyContact: new FormControl(''),
      updatedFields: new FormControl(''),
    }
  )
  bankForm: FormGroup = new FormGroup(
    {
      paymentElection: new FormControl('ACH'),
      isVendorActive: new FormControl(false),
      nameOfBank: new FormControl('', [Validators.required]),
      accountType: new FormControl('', [Validators.required]),
      accountNumber: new FormControl('', [Validators.required]),
      ConfirmAccNum: new FormControl('', [Validators.required]),
      bankRoutingNumber: new FormControl('', [Validators.required]),
      companyTaxId: new FormControl('', [Validators.required]),
      bankAddress: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zip: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ]),
      country: new FormControl('US', [Validators.required]),
      bankContact: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      paymentEmailAddress: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      companyName: new FormControl(''),
      companyContact: new FormControl(''),
      vendorId: new FormControl(''),
      lastName: new FormControl(''),
      email: new FormControl(''),
      phone: new FormControl(''),
      vendorRegistrationId: new FormControl(''),
      addr1: new FormControl(''),
      addr2: new FormControl(''),
      customerId: new FormControl(this.custId),
      secondaryOtherDetail: new FormControl(''),
      secondaryEmail: new FormControl(''),
      secondaryPhone: new FormControl(''),
      secondaryCompanyContact: new FormControl(''),
      updatedFields: new FormControl(''),
    }
  )
  secondaryForm: FormGroup = new FormGroup(
    {
      paymentElection: new FormControl('ACH'),
      isVendorActive: new FormControl(false),
      secondaryOtherDetail: new FormControl(''),
      secondaryEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      secondaryPhone: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      secondaryCompanyContact: new FormControl('', [Validators.required]),
      nameOfBank: new FormControl(''),
      accountType: new FormControl(''),
      accountNumber: new FormControl(''),
      bankRoutingNumber: new FormControl(''),
      companyTaxId: new FormControl(''),
      bankAddress: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      country: new FormControl('US'),
      bankContact: new FormControl(''),
      paymentEmailAddress: new FormControl(''),
      companyName: new FormControl(''),
      companyContact: new FormControl(''),
      vendorId: new FormControl(''),
      lastName: new FormControl(''),
      email: new FormControl(''),
      phone: new FormControl(''),
      vendorRegistrationId: new FormControl(''),
      addr1: new FormControl(''),
      addr2: new FormControl(''),
      customerId: new FormControl(this.custId),
      updatedFields: new FormControl(''),
    })

  // Document : File;
  fileForm: FormGroup = new FormGroup(
    {
      documentName: new FormControl(FileList, [Validators.required]),
      vendorId: new FormControl(''),
      vendorName: new FormControl(''),
      w9DocumentId: new FormControl(''),
      companyName: new FormControl(''),
      documentPath: new FormControl(''),
      createdDate: new FormControl((new Date()).toISOString().substring(0, 10)),
      createdBy: new FormControl(''),
      w9VerifiedYear: new FormControl(''),
      w9Verified: new FormControl(''),
      typeOfDoc: new FormControl(''),
      modifiedDate: new FormControl(''),
      modifiedBy: new FormControl('')
    })

  get fileForms() {
    return this.fileForm.controls;
  }
  onFieldChange = function (value: string) {
    var fieldV = '';
    var originalV = '';
    var arrayKey = '';

    switch (value) {
      case 'fm':
        fieldV = this.primaryForm.value.companyName;
        originalV = this.vendorDetailRespone['companyName'] !== null ? this.vendorDetailRespone['companyName'] : "";
        arrayKey = "First Name (Primary Details)";

        break;
      case 'lm':
        fieldV = this.primaryForm.value.lastName;
        originalV = this.vendorDetailRespone['lastName'] !== null ? this.vendorDetailRespone['lastName'] : "";
        arrayKey = "Last Name (Primary Details)";

        break;
      case 'email':
        fieldV = this.primaryForm.value.email;
        originalV = this.vendorDetailRespone['email'] !== null ? this.vendorDetailRespone['email'] : "";
        arrayKey = "Email (Primary Details)";

        break;
      case 'phone':
        fieldV = this.primaryForm.value.phone;
        originalV = this.vendorDetailRespone['phone'] !== null ? this.vendorDetailRespone['phone'] : "";
        arrayKey = "Phone Number (Primary Details)";

        break;
      case 'rn':
        fieldV = this.bankForms.bankRoutingNumber;
        originalV = this.vendorDetailRespone['bankRoutingNumber'] !== null ? this.vendorDetailRespone['bankRoutingNumber'] : "";
        arrayKey = "Routing Number (Bank Details)";

        break;
      case 'ctid':
        fieldV = this.bankForms.companyTaxId;
        originalV = this.vendorDetailRespone['companyTaxId'] !== null ? this.vendorDetailRespone['companyTaxId'] : "";
        arrayKey = "Tax ID Number (Bank Details)";

        break;
      case 'zip':
        fieldV = this.bankForms.zip;
        originalV = this.vendorDetailRespone['zip'] !== null ? this.vendorDetailRespone['zip'] : "";
        arrayKey = "Zip Code (Bank Details)";

        break;
      case 'bn':
        fieldV = this.bankForms.nameOfBank;
        originalV = this.vendorDetailRespone['nameOfBank'] !== null ? this.vendorDetailRespone['nameOfBank'] : "";
        arrayKey = "Bank Name (Bank Details)";

        break;
      case 'bAdd':
        fieldV = this.bankForms.bankAddress;
        originalV = this.vendorDetailRespone['bankAddress'] !== null ? this.vendorDetailRespone['bankAddress'] : "";
        arrayKey = "Bank Address (Bank Details)";

        break;
      case 'state':
        fieldV = this.bankForms.state;
        originalV = this.vendorDetailRespone['state'] !== null ? this.vendorDetailRespone['state'] : "";
        arrayKey = "State (Bank Details)";

        break;
      case 'an':
        fieldV = this.bankForms.accountNumber;
        originalV = this.vendorDetailRespone['accountNumber'] !== null ? this.vendorDetailRespone['accountNumberstate'] : "";
        arrayKey = "Account Number (Bank Details)";

        break;
      case 'pea':
        fieldV = this.bankForms.paymentEmailAddress;
        originalV = this.vendorDetailRespone['paymentEmailAddress'] !== null ? this.vendorDetailRespone['paymentEmailAddress'] : "";
        arrayKey = "Email (Bank Details)";

        break;
      case 'city':
        fieldV = this.bankForms.city;
        originalV = this.vendorDetailRespone['city'] !== null ? this.vendorDetailRespone['city'] : "";
        arrayKey = "City (Bank Details)";

        break;
      case 'acntType':
        fieldV = this.bankForms.city;
        originalV = this.vendorDetailRespone['accountType'] !== null ? this.vendorDetailRespone['accountType'] : "";
        arrayKey = "Account Type (Bank Details)";

        break;
      case 'bContact':
        fieldV = this.bankForms.bankContact;
        originalV = this.vendorDetailRespone['bankContact'] !== null ? this.vendorDetailRespone['bankContact'] : "";
        arrayKey = "Phone Number (Bank Details)";

        break;
      case 'bContact':
        fieldV = this.bankForms.bankContact;
        originalV = this.vendorDetailRespone['bankContact'] !== null ? this.vendorDetailRespone['bankContact'] : "";
        arrayKey = "Phone Number (Bank Details)";

        break;
      case 'sContact':
        fieldV = this.secForms.secondaryCompanyContact;
        originalV = this.vendorDetailRespone['secondaryCompanyContact'] !== null ? this.vendorDetailRespone['secondaryCompanyContact'] : "";
        arrayKey = "Secondary Contact (Secondary Details)";

        break;
      case 'sPhone':
        fieldV = this.secForms.secondaryPhone;
        originalV = this.vendorDetailRespone['secondaryPhone'] !== null ? this.vendorDetailRespone['secondaryPhone'] : "";
        arrayKey = "Phone Number (Secondary Details)";

        break;
      case 'sEmail':
        fieldV = this.secForms.secondaryEmail;
        originalV = this.vendorDetailRespone['secondaryEmail'] !== null ? this.vendorDetailRespone['secondaryEmail'] : "";
        arrayKey = "E-mail (Secondary Details)";

        break;
      case 'sOtherDet':
        fieldV = this.secForms.secondaryOtherDetail;
        originalV = this.vendorDetailRespone['secondaryOtherDetail'] !== null ? this.vendorDetailRespone['secondaryOtherDetail'] : "";
        arrayKey = "Other Details (Secondary Details)";

        break;

      default:
        break;
    }

    if (fieldV !== originalV) {
      if (this.updatedVendorField.indexOf(arrayKey) === -1) {
        this.updatedVendorField.push(arrayKey);
      }
    }
    else {
      if (this.updatedVendorField.indexOf(arrayKey) !== -1) {
        var index = this.updatedVendorField.indexOf(arrayKey);
        this.updatedVendorField.splice(index, 1);
      }
    }
    console.log(this.updatedVendorField);
  }

  onPrimarySubmit() {
    if (!this.status) {
      this.primaryForm.enable();
      this.status = true;
    }
    else {
      this.submitted = true;
      this.isLoad = true;
      if (this.primaryForm.valid) {
        // this.primaryForm.value.companyContact = this.primaryForm.value.vendorId
        if (this.bankForm.valid && this.secondaryForm.valid) {
          this.primaryForm.value.isVendorActive = true;
        }
        const token = this.authService.getToken();
        this.primaryForm.value.updatedFields = this.updatedVendorField?.toString();
        this.vendorService.updateVendor(this.primaryForm.value, token)
          .subscribe((response) => {
            console.log(response);
            this.alertService.success('Success!! Primary Details Saved SuccessFully.', this.options);
            this.primaryForm.disable();
            setTimeout(() => {
              this.isLoad = false;
            }, 200);
            this.status = false;
            setTimeout(() => {
              this.commonService.reloadComponent(true);
            }, 1000)
          }, (err) => {
            console.log(err);
            this.alertService.error(err.error.error, this.options);
            if (err.error.errors) {
              this.alertService.error(err.error.errors.Messages[0], this.options);
            }
            this.isLoad = false;
          })
      } else {
        console.log("Please enter valid details");
        // this.alertService.error('Error !! Please Enter Valid Details.', this.options);
        this.isLoad = false;
      }
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onBankSubmit() {
    if (!this.statusBank) {
      this.bankForm.enable();
      this.statusBank = true;
    } else {
      this.submitted = true;
      this.isBankLoad = true;
      if (this.bankForm.valid) {
        if (this.bankForm.value.accountNumber == this.bankForm.value.ConfirmAccNum) {
        //this.bankForm.value.companyContact = this.bankForm.value.vendorId
        if (this.primaryForm.valid && this.secondaryForm.valid) {
          this.bankForm.value.isVendorActive = true;
        }
        const token = this.authService.getToken();
        this.bankForm.value.updatedFields = this.updatedVendorField?.toString();

        this.vendorService.updateVendor(this.bankForm.value, token)
          .subscribe((response) => {
            console.log(response);
            this.bankForm.disable();
            this.statusBank = false;
            this.alertService.success('Success!! Bank Details Saved SuccessFully.', this.options);
            setTimeout(() => {
              this.isBankLoad = false;
            }, 200)
            setTimeout(() => {
              this.commonService.reloadComponent(true);
            }, 2000)
          }, (err) => {
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
            this.isBankLoad = false;
          })
        }
        else {
          this.alertService.error('Error!! Account number and confirm account number should be same.', this.options);
          this.isBankLoad = false;
        }
      } else {
        console.log("Please enter valid details");
        // this.alertService.error('Error !! Please Enter Valid Details.', this.options);
        this.isBankLoad = false;
      }
    }
  }

  onSecondarySubmit() {
    if (!this.statusSec) {
      this.secondaryForm.enable();
      this.statusSec = true;
    } else {
      this.submitted = true;
      this.isSecLoad = true;
      const token = this.authService.getToken();
      if (this.secondaryForm.valid) {
        if (this.bankForm.valid && this.primaryForm.valid) {
          this.secondaryForm.value.isVendorActive = true;
        }
        //this.secondaryForm.value.companyContact = this.secondaryForm.value.vendorId
        this.secondaryForm.value.updatedFields = this.updatedVendorField?.toString();

        this.vendorService.updateVendor(this.secondaryForm.value, token)
          .subscribe((response) => {
            console.log(response);
            this.secondaryForm.disable();
            this.statusSec = false;
            this.alertService.success('Success!! Secondary Details Saved SuccessFully.', this.options);
            setTimeout(() => {
              this.isSecLoad = false;
            })
            setTimeout(() => {
              this.commonService.reloadComponent(true);
            }, 2000)
          }, (err) => {
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
            this.isSecLoad = false;
          })
      } else {
        console.log("Please enter valid details");
        // this.alertService.error('Error !! Please Enter Valid Details.', this.options);
        this.isSecLoad = false;
      }
    }
  }

  resetPri() {
    this.primaryForm.disable();
    this.status = false;
  }

  resetBank() {
    this.bankForm.disable();
    this.statusBank = false;
  }

  resetSec() {
    this.secondaryForm.disable();
    this.statusSec = false;
  }

  get primaryForms() {
    return this.primaryForm.controls;
  }

  get bankForms() {
    return this.bankForm.controls;
  }

  get secForms() {
    return this.secondaryForm.controls;
  }

  onFilechange($event: any) {
    let file = $event.target.files;
    this.fileForm.value.documentName = file;
    console.log(this.fileForm.value.documentName);
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  getCountries() {
    return this.countryData.getCountries();
  }

  getStatesByCountry(countryShotName: string) {
    return this.countryData.getStatesByShort(countryShotName);
  }

  getCitiesByState(country: any, state: any) {
    return this.countryData.getCities(country, state);
  }

  uploadVendorDoc() {
    console.log(this.fileForm.value.documentName.length);
    if (!this.fileForm.value.documentName.length) {
      this.alertService.error('Error! Please upload the file first.', this.options);
    }
    else {
      this.isLoading = true;
      this.vendorService.uploadVendorDoc(this.fileForm.value.documentName, this.vendorId,
        this.vendorRegistrationId, this.custId)
        .subscribe((response: any) => {
          console.log(response);
          this.isLoading = false;
          this.vendorDocsDetails(this.vendorRegistrationId);
          setTimeout(() => {
            this.alertService.success('Success!! Document Uploaded SuccessFully.', this.options);
          }, 1500);
        }, (err) => {
          this.isLoading = false;
          console.log(err);
          this.alertService.error(err.error.errors.Messages[0], this.options);
        })
    }
  }

  //download
  public createURL = (fileName: any, filePath: any) => {
    return environment.BaseApiUrl + `/W9Documents/downloadFile?docPath=${filePath}&fileName=${fileName}`;
  }

  //update vendor document
  updateVendorDoc(docObject) {
    this.isLoading = true;
    //get csrf token
    this.vendorService.csrfToken().subscribe((response: any) => {
      console.log(response);
      console.log(response.csrfToken);
      this.vendorService.updateVendorDoc(docObject, response.csrfToken).subscribe((response: any) => {
        console.log(response);
        this.isLoading = false;
        this.alertService.success('Success!! Document Updated SuccessFully.', this.options);
        this.vendorDocsDetails(this.vendorRegistrationId);
      }, (err) => {
        console.log(err);
        this.isLoading = false;
        this.alertService.error(err.error, this.options);
      })
    })
  }

  //bank acc routing num
  routingNum() {
    this.loginService.createBankAccountRoutingNum(this.bankForm.value.bankRoutingNumber, this.token).
      subscribe((response: any) => {
        console.log(response);
        console.log(response.bankName);
        this.bankForm.patchValue({
          nameOfBank: response.bankName,
          bankRoutingNumber: response.routingNumber,
          bankAddress: response.address,
          zip: response.zip,
          bankContact: response.telePhone,
        });

        this.zipCodeService.getDetailByZip(response.zip).subscribe((data: any) => {
          console.log(data);
          if (data == null) {
            return;
          }
          this.cities = data.places.map((place: any) => place['city']);
          this.states = data.places.map((place: any) => { return { 'state': place['state'], 'stateId': place['stateAbbreviation'] } });
        }, (err) => {
          console.log(err);
        });

        if (response.message !== 'OK') {
          this.alertService.error(response.message, this.options);
        }
      }, (err) => {
        console.log(err);
      })
  }



  vendorDocsDetails(vendorRegistrationId: any) {
    this.vendorService.getVendorDoc(vendorRegistrationId, this.token).subscribe((vresult: any) => {
      console.log("vresult", vresult);
      this.dataa = vresult;
      this.dataSource.data = this.dataa;
      this.dataSource.sort = this.empTbSort;
    }, (error) => {
      console.log(error);
    })
  }

  onPressPrimary(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.primaryForm.value.phone = event.target.value
    }
  }

  onPressBank(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.bankForm.value.bankContact = event.target.value
    }
  }

  onPressSec(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.secondaryForm.value.secondaryPhone = event.target.value
    }
  }

  routingNumValidations(event) {
    const inputValue = event.target.value;
    const maxDigits = 8;
    if (event.target.value.length > 8) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.bankForm.value.bankRoutingNumber = event.target.value
    }
  }

  async vendorState() {
    this.isLoading = true;
    return new Promise<void>((resolve, reject) => {
      this.vendorService.vendorState().subscribe(
        (response: any) => {
          console.log('vendorstate', response);
          this.states = response;
          console.log(this.states);
          this.bankForm.get('state').enable();
          resolve(); // Resolve the promise when the response is received
          this.isLoading = false;
        },
        (error) => {
          reject(error); // Reject the promise in case of an error
          this.isLoading = false;
        }
      );
    });
  }


  //year
  private updateYears() {
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let i = 0; i < 4; i++) {
      this.years.push(currentYear - i);
    }
  }

  onYearChange($event: any, docObject) {
    console.log('Selected Year:', $event.value);
    docObject.w9VerifiedYear = $event.value;
  }

  onTypeChange($event, docObject) {
    docObject.typeOfDoc = $event.value;
  }

  onDateChange(docObject) {
    docObject.createdDate = new Date();
  }

  //vendor toggle
  vendorToggle() {

    if (!this.IsVendorActive && (!this.primaryForm.valid || !this.secondaryForm.valid || !this.bankForm.valid)) {
      this.alertService.error('Please fill complete detail to activate vendor', this.options);
      return;
    }

    this.vendorService.vendorTogggle(this.vendorRegistrationId, !this.IsVendorActive).subscribe((response) => {
      this.IsVendorActive = !this.IsVendorActive;
      console.log('toggleVendor', response)
    }, (err) => {
      console.log(err);
    })
  }

  // vendorToggle() {
  //   // this.IsVendorActive = !this.IsVendorActive;
  //   this.vendorService.vendorTogggle(this.vendorRegistrationId, this.IsVendorActive).subscribe((response) => {
  //     console.log('toggleVendor', response)
  //   }, (err) => {
  //     console.log(err);
  //     this.IsVendorActive = !this.IsVendorActive;
  //   })
  // }

  onZipCodeChange(event: any) {
  const zip = event.target.value;

  // Clear previous values
  this.cities = [];
  this.states = [];

  if (!zip || zip.length !== 5) return;

  this.zipCodeService.getDetailByZip(zip).subscribe((data: any) => {
    console.log('ZIP response:', data);

    if (!data || !data.places || data.places.length === 0) {
      return;
    }

    // Map cities and states
    this.cities = data.places.map((place: any) => place['city']);
    this.states = data.places.map((place: any) => ({
      state: place['state'],
      stateId: place['stateAbbreviation']
    }));

    // ✅ Auto-populate first city and state
    const firstCity = this.cities[0];
    const firstState = this.states[0]?.stateId;

    if (firstCity && firstState) {
      this.bankForm.patchValue({
        city: firstCity,
        state: firstState
      });

      // Optional: Trigger any downstream logic
      this.onFieldChange('city');
      this.onFieldChange('state');
    }
  }, (err) => {
    console.error('ZIP lookup failed:', err);
  });
}}